import React, { useState } from 'react';
import PropTypes from 'prop-types';

const InternalTopMenu = ({ onLogout }) => {
  const [open, setOpen] = useState(false);

  const toggle = () => setOpen((prev) => !prev);
  const close = () => setOpen(false);

  return (
    <div className="relative">
      <button
        type="button"
        onClick={toggle}
        className="flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-2 text-sm text-slate-600 shadow-sm hover:bg-slate-100 transition-colors"
      >
        <i className="bi-gear-fill text-lg"></i>
      </button>
      {open && (
        <div className="absolute right-0 mt-3 w-56 rounded-xl border border-slate-200 bg-white py-2 shadow-lg">
          <a
            href="/account/edit"
            className="flex items-center gap-2 px-4 py-2 text-sm text-slate-700 hover:bg-slate-100 transition-colors"
            onClick={close}
          >
            <i className="bi-person"></i> Dados Pessoais
          </a>
          <a
            href="/security/changepassword"
            className="flex items-center gap-2 px-4 py-2 text-sm text-slate-700 hover:bg-slate-100 transition-colors"
            onClick={close}
          >
            <i className="bi-key"></i> Alterar Senha
          </a>
          <a
            href="/bank/pix"
            className="flex items-center gap-2 px-4 py-2 text-sm text-slate-700 hover:bg-slate-100 transition-colors"
            onClick={close}
          >
            <i className="bi-key"></i> Chaves PIX
          </a>
          <a
            href="/account/level"
            className="flex items-center gap-2 px-4 py-2 text-sm text-slate-700 hover:bg-slate-100 transition-colors"
            onClick={close}
          >
            <i className="bi-star"></i> Níveis de Conta
          </a>
          <hr className="my-2" />
          <button
            type="button"
            onClick={() => {
              close();
              onLogout();
            }}
            className="flex w-full items-center gap-2 px-4 py-2 text-left text-sm text-red-600 hover:bg-red-50 transition-colors"
          >
            <i className="bi-box-arrow-right"></i> Logout
          </button>
        </div>
      )}
    </div>
  );
};

InternalTopMenu.propTypes = {
  onLogout: PropTypes.func.isRequired,
};

export default InternalTopMenu;


